
<template>
  <v-form ref="form">
    <v-card flat>
      <v-card-text>
        <SelectModality :object_with_model="employee" multiple model="modality_ids" custom_label="Selecione os módulos que o funcionário terá acesso"/>
        <v-autocomplete v-model="employee.jobDetails.job_name" :items="allRoles" label="Cargo"
          prepend-icon="mdi-clipboard-account" hide-no-data item-text="attributes.translated"
          item-value="attributes.name" item-disabled="attributes.hide" :rules="[...required]"
          @input="checkComissions(employee.jobDetails.job_name)">
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
        <v-text-field v-money="money" v-model="employee.jobDetails.salary" label="Salário (R$)"
          prepend-icon="mdi-cash-multiple"></v-text-field>
        <template v-if="[2, 3].includes(employee.jobDetails.job)">
          <v-text-field label="Meta (sacos vendidos)" v-model="employee.goals_attributes.goal"
            prepend-icon="mdi-bullseye" :rules="[...required]" type="tel" v-mask="'############'"></v-text-field>
        </template>
        <template v-if="has_comission">
          <v-subheader>Comissão padrão</v-subheader>
          <v-autocomplete v-model="employee.jobDetails.comissionType" :items="comissions"
            label="Modelo de comissão" prepend-icon="mdi-cart-plus" hide-no-data item-text="name"
            item-value="value" item-disabled="off" @change="prepareJobDetails()" :rules="[...notSoRequired]"
            v-if="has_comission">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>
  
          <v-text-field v-money="money" :rules="[...required]" v-model="employee.jobDetails.comissionFloor"
            v-if="employee.jobDetails.comissionType == 1" label="Informe o valor (R$)"
            prepend-icon="mdi-currency-usd"></v-text-field>
          <v-text-field v-money="money" :rules="[...notZeroPercentage]"
            v-model="employee.jobDetails.comissionFloor" v-if="employee.jobDetails.comissionType == 2"
            label="Informe a porcentagem (%)" prepend-icon="mdi-percent" hint="% do lucro"></v-text-field>
          <v-text-field v-money="money" :rules="[...required]" v-model="employee.jobDetails.comissionFloor"
            v-if="employee.jobDetails.comissionType == 4" label="Informe o valor (R$)"
            prepend-icon="mdi-currency-usd"></v-text-field>
  
          <v-text-field v-money="money" :rules="[...required, ...notZero]"
            v-model="employee.jobDetails.comissionFloor" v-if="employee.jobDetails.comissionType == 3"
            label="Comissão inicial (R$)" prepend-icon="mdi-currency-usd"></v-text-field>
          <v-text-field v-money="money" :rules="[...required, ...notZero]"
            v-model="employee.jobDetails.profitFloor" v-if="employee.jobDetails.comissionType == 3"
            label="Lucro inicial (R$)" prepend-icon="mdi-currency-usd"></v-text-field>
          <v-text-field v-money="money3" :rules="[...required, ...notZero3]"
            v-model="employee.jobDetails.profitStep" v-if="employee.jobDetails.comissionType == 3"
            label="Lucro incremental (R$)" prepend-icon="mdi-currency-usd"></v-text-field>
          <v-text-field v-money="money3" :rules="[...required, ...notZero3]"
            v-model="employee.jobDetails.comissionStep" v-if="employee.jobDetails.comissionType == 3"
            label="Comissão incremental (R$)" prepend-icon="mdi-currency-usd"></v-text-field>
          <v-text-field v-money="money" :rules="[...notZeroPercentage]"
            v-model="employee.jobDetails.comissionStep" hint="% do lucro"
            v-if="employee.jobDetails.comissionType == 5" label="Informe a porcentagem (%)"
            prepend-icon="mdi-percent"></v-text-field>
        </template>
        <template v-if="has_comission && [2, 3].includes(employee.jobDetails.job)">
          <v-divider></v-divider>
          <v-subheader>Comissão por produto e marca</v-subheader>
          <list-comission class="pb-5" @new-changed="changeNew" :main_data="employee"></list-comission>
        </template>
        <v-text-field v-if="employee.jobDetails.job == 4" :rules="[...required]"
          v-model="employee.driver_attributes.cnh" label="CNH" v-mask="'###########'" prepend-icon="mdi-text-short"
          lazy></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="emitChangeStepper(false)"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
        <v-btn text @click="emitChangeStepper(true)"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import validations from "@/mixins/validations.js"
import Api from '@/api/index';
import { VMoney } from 'v-money'

export default {
  name: 'EmployeeSalaryForm',
  mixins: [validations],
  directives: { money: VMoney },
  props:{
    employee: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: {
    OneComission: () => import('@/_backoffice/_registrations/components/supplier/products/OneComission.vue'),
    ListComission: () => import('@/_backoffice/_registrations/components/supplier/products/ListComission.vue'),
    SelectModality: () => import("@/components/shared/SelectModality.vue"),
  },
  data() {
    return {
      comissions: [{ name: 'Modelo 1 - R$ por unidade', value: 1, off: false },
      { name: 'Modelo 2 - % do lucro', value: 2, off: false },
      { name: 'Modelo 3 - Faixas', value: 3, off: false },
      { name: 'Modelo 4 - Gerente', value: 4, off: false },
      { name: 'Modelo 5 - Motorista', value: 5, off: false }],
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      money3: {
        decimal: '.',
        thousands: ',',
        precision: 3,
        masked: true
      },
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    emitChangeStepper(increment){
      if(increment){
        this.prepareData()
      }
      this.$emit("changeStepper", increment)
    },
    getData() {
      this.getRoles();
    },
    checkComissions(job) {
      this.employee.jobDetails.comissionType = null
      this.employee.jobDetails.job = Number(this.allRoles.find(obj => obj.attributes.name == job).id)
      job = this.employee.jobDetails.job
      this.comissions.forEach(comission => {
        comission.off = false
      });
      if (job == 'Seller' || job == 'Representative' || job == 2) {//vendedor
        this.comissions[3].off = true
        this.comissions[4].off = true

      } else if (['Analyst', 'SalesExecutive', 'Financial', 'Auxiliar', 'Director', 'Logistics'].includes(job) ||
        [14, 13, 5, 1, 6, 7].includes(job)) {//financeiro 5 + aux 80 + exec 6 => true ALL
        if (job == 'Financial' || job == 5) {
          this.employee.brand_ids = []
        }
        this.comissions.forEach(comission => {
          comission.off = true
        });
      } else if (job == 'Manager' || job == 3) {//gerente, id3
        this.employee.brand_ids = []
        this.comissions.forEach(comission => {
          comission.off = true
        });
        this.comissions[3].off = false
        this.employee.jobDetails.comissionType = this.comissions[3].value
      } else if (job == 'Driver' || job == 4) {//motorista
        this.comissions.forEach(comission => {
          comission.off = true
        });
        this.comissions[4].off = false
        this.employee.jobDetails.comissionType = this.comissions[4].value
      }
      if (job != 'Manager' || job != 3 || job != 'Financial' || job != 5) {
        this.employee.brand_ids = null
      }

    },
    prepareJobDetails() {
      var comission_type = this.employee.jobDetails.comissionType

      if (comission_type == 1 || comission_type == 2 || comission_type == 4) {
        this.employee.jobDetails.profitFloor = 0
        this.employee.jobDetails.profitStep = 0
        this.employee.jobDetails.comissionStep = 0
      }
    },
    prepareComissionType(comission_type) {
      if (comission_type == 1 || comission_type == 4) {
        this.employee.jobDetails.comissionTypeEnum = 3
      } else if (comission_type == 2 || comission_type == 5) {
        this.employee.jobDetails.comissionTypeEnum = 1
      } else if (comission_type == 3) {
        this.employee.jobDetails.comissionTypeEnum = 2
      } else {
        this.employee.jobDetails.comissionTypeEnum = 0
      }
    },
    prepareData(){
      if (this.employee.jobDetails.job == 4) {
        this.prepareDriver()
      }
      this.prepareComissionType(this.employee.jobDetails.comissionType)
      this.prepareJobDetails()
    },
    prepareDriver() {
      this.employee.driver_attributes.name = this.employee.user_attributes.name
      this.employee.driver_attributes.external = false
      this.employee.driver_attributes.status_id = 1
      this.employee.driver_attributes.receipt_config = {
        kind: 'cash',
        kinds: ['cash'],
      }
    },
    changeNew(e) {
      this.employee.comissions_attributes[e.idx] = { ...e.comission }
    },
    ...mapActions({
      getRoles: 'EmployeeRole/index',
    })
  },
  computed: {
    has_comission() {
      if (this.employee.jobDetails.job_name) {
        return !['Director', 'Financial', 'Logistics', 'Analyst',].includes(this.employee.jobDetails.job_name)
      }
    },
    ...mapState({
      allRoles: state => state.EmployeeRole.allRoles,
    })
  },
  mounted() {
    this.getData()
  },
  watch:{
    allRoles(nv){
      this.allRoles.map(role => {
          if (this.isDirector()) {
            role.attributes.hide = false
          } else if (this.isFinancial()) {
            switch (role.attributes.name) {
              case 'Seller':
                role.attributes.hide = false
                break;
              case 'Driver':
                role.attributes.hide = false
                break;
              default:
                role.attributes.hide = true
                break;
            }
          } else if (this.isManager()) {
            switch (role.attributes.name) {
              case 'Director':
                role.attributes.hide = true
                break;
              default:
                role.attributes.hide = false
                break;
            }
          }
        })
    }
  }
}
</script>
